import React from "react";

const TermsPage = () => {
  return (
    <div className="legal-page">
      <h1>Terms of Use</h1>
      <p className="legal-muted">
        This document is a template Terms of Use for the CrunchAlpha
        application. The final version will follow the language provided by
        legal and compliance.
      </p>

      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>
          By registering for and using the CrunchAlpha platform, you agree to be
          bound by these Terms of Use and any additional policies referenced
          herein.
        </p>
      </section>

      <section>
        <h2>2. Nature of Service</h2>
        <p>
          CrunchAlpha provides technology infrastructure to connect trading
          accounts, calculate performance and risk metrics, and facilitate
          relationships between Traders, Investors, and Analysts. CrunchAlpha is
          not a broker and does not execute, hold, or guarantee any trades.
        </p>
      </section>

      <section>
        <h2>3. Eligibility</h2>
        <ul>
          <li>You are at least 18 years old.</li>
          <li>You have the legal capacity to enter into a binding agreement.</li>
          <li>
            You are not prohibited by local regulations from engaging in trading
            or investing activities.
          </li>
        </ul>
      </section>

      <section>
        <h2>4. User Accounts</h2>
        <p>
          You are responsible for maintaining the confidentiality of your login
          credentials and for all activities that occur under your account.
          CrunchAlpha may suspend or terminate access if suspicious or abusive
          behavior is detected.
        </p>
      </section>

      <section>
        <h2>5. Prohibited Activities</h2>
        <ul>
          <li>Manipulating performance data or misrepresenting track records.</li>
          <li>Engaging in money laundering or other illegal activities.</li>
          <li>
            Attempting to exploit bugs, bypass security, or gain unauthorized
            access.
          </li>
        </ul>
      </section>

      <section>
        <h2>6. Limitation of Liability</h2>
        <p>
          CrunchAlpha is not liable for any financial losses arising from
          trading decisions, signals, or strategies displayed on the platform.
          You use the service entirely at your own risk.
        </p>
      </section>

      <section>
        <h2>7. Changes to Terms</h2>
        <p>
          We may update these Terms from time to time. Material changes will be
          communicated via email or in-app notifications.
        </p>
      </section>
    </div>
  );
};

export default TermsPage;
